export class Fases {
    public static readonly FASE_ANALISE_ANALISTA = 'Em Análise pelo Analista'
    public static readonly FASE_ANALISE_GERENTE = 'Em Análise pelo Gerente'
    public static readonly FASE_ANALISE_CHEFE = 'Em Análise pelo Chefe de Departamento'
}
  